























import Vue from 'vue'
import { InhalerProduct, InhalerTypes } from '@/jsonapi/CommonTypes'
import ChartCardContainer from '@/components/layouts/ChartCardContainer.vue'
import { joinWith } from '@/utils/labels'
import * as R from 'ramda'
import { PatientWithEventsEvent } from '@/jsonapi/PatientWithEvents'
import { PatientEventCodeCategory } from '@/view-model/patient-event-constants/EventCode'
import { getRescueInhalerUsages } from '@/utils/inhalers'
import { USER_TIME_ZONE } from '@/utils/time'
import { rescueInhalerChartOptions } from '@/components/patient-stats/graphs/summary-reports/chart-options/rescue-inhaler-charts/RescueInhalerChartOptions'

export default Vue.extend({
  components: {
    ChartCardContainer,
  },
  props: {
    patientId: {
      type: String,
      required: true,
    },
    patientWithStats: {
      type: Object,
      required: true,
    },
  },
  computed: {
    activeRescueInhalers(): InhalerProduct[] {
      if (!this.patientWithStats || !this.patientWithStats.activeInhalers) {
        return []
      }
      return this.patientWithStats.activeInhalers.filter(inhaler => inhaler.productType === InhalerTypes.Reliever)
    },
    activeInhalerNames(): Array<Pick<InhalerProduct, 'productName'>> {
      return this.activeRescueInhalers.map(inhaler => inhaler.productName)
    },
    inhalerUsageTitle() {
      if (!this.activeInhalerNames.length) {
        return ''
      }
      return `${joinWith(this.activeInhalerNames)} ${this.activeInhalerNames.length > 1 ? 'Usages' : 'Usage'}`
    },
    relieverInhalerEvents() {
      return R.pathOr([], ['consolidatedDailyEvents'], this.patientWithStats).filter(
        (event: PatientWithEventsEvent) => {
          const isRelieverInhalerEvent =
            String(event.eventCode).startsWith(String(PatientEventCodeCategory.RelieverInhaler)) ||
            String(event.eventCode).startsWith(String(PatientEventCodeCategory.AbnormalInhaler))
          const hasValidTimestamp =
            event.eventTimestamp > this.patientWithStats.resultStartTimestamp &&
            event.eventTimestamp < this.patientWithStats.resultEndTimestamp
          return isRelieverInhalerEvent && hasValidTimestamp
        }
      )
    },
    inhalerUsagesDaily() {
      return this.patientWithStats && this.patientWithStats.inhalerUsagesDaily
    },
    rescueInhalerUsagesDaily() {
      return this.inhalerUsagesDaily && getRescueInhalerUsages(this.inhalerUsagesDaily)
    },
    hasAssignedRescueInhaler(): boolean {
      return (
        this.patientWithStats &&
        this.patientWithStats.assignedInhalers &&
        !!this.patientWithStats.assignedInhalers.find(inhaler => inhaler.productType === InhalerTypes.Reliever)
      )
    },
    rescueInhalerChartOptions() {
      if (!this.patientWithStats) {
        return null
      }
      const timezone = this.patientWithStats.timezone || USER_TIME_ZONE
      return rescueInhalerChartOptions({
        timezone: timezone,
        rescueInhalerUsagesDaily: this.rescueInhalerUsagesDaily,
        startTimestamp: this.patientWithStats.resultStartTimestamp,
        endTimestamp: this.patientWithStats.resultEndTimestamp,
        colors: this.$vuetify.theme.themes.light,
        relieverInhalerEvents: this.relieverInhalerEvents,
      })
    },
  },
})
